import _ from "lodash";

export const getOriginalFileName = ({
  file,
}: {
  file: { original_file_name: string | null; file_url?: string };
}) =>
  file.original_file_name ||
  _.last(file?.file_url?.split("/")) ||
  "proforma.xlsx";
